import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@/components/atoms/Icon/Icon';
import clsx from 'clsx';
import * as React from 'react';
const SegmentedControl = ({ className, items, selectedItemKey, variant = 'solid', }) => {
    const tabRefs = React.useRef([]);
    const onKeyDown = (e, idx) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            let newIndex = idx + (e.key === 'ArrowRight' ? 1 : -1);
            if (newIndex < 0)
                newIndex = items.length - 1;
            if (newIndex >= items.length)
                newIndex = 0;
            tabRefs.current[newIndex]?.focus();
        }
    };
    return (_jsx("div", { className: clsx('flex h-3', className), role: "tablist", children: items.map((item, idx) => (_jsxs("button", { ref: (el) => (tabRefs.current[idx] = el), className: clsx('focus-inset flex w-full items-center justify-center gap-0.5 border-b', selectedItemKey === item.key
                ? 'border-border-primary text-text-primary'
                : 'border-border-muted text-text-secondary', item.className, variant === 'solid' && 'bg-surface-utility'), role: "tab", tabIndex: selectedItemKey !== item.key ? undefined : -1, "aria-selected": selectedItemKey === item.key, "aria-label": item.label, "data-testid": item.dataTestId, onClick: item.onClick, onKeyDown: (e) => onKeyDown(e, idx), children: [item.icon && _jsx(Icon, { variant: item.icon, className: "aspect-square w-1.5" }), _jsx("span", { className: "type-body-small-demi", children: item.label })] }, item.key))) }));
};
export default SegmentedControl;
